export default __webpack_public_path__ + "static/media/neighborhood3.a46e4d03.jpg";